function enviar_form(){

    console.log("Envia");

    var filter= /^[a-zA-Z0-9_\.\-]+@[a-zA-Z0-9\-]+\.[a-zA-Z0-9\-\.]+$/;
    var s_email = $('#email').val();
    var s_name = $('#nombre').val();  
    var s_apellido = $('#telefono').val();  
    var s_msg = $('#mensaje').val();
    var sendMail = "true";

    if (filter.test(s_email)){
        $('#error-email').addClass("hide");      
    } else{
        //$('#error-email').removeClass("hide"); 
        toastr["error"]("Correo electrónico inválido")
        toastr.options = {
          "closeButton": false,
          "debug": true,
          "newestOnTop": false,
          "progressBar": false,
          "positionClass": "toast-top-right",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }   
        sendMail = "false";
    }

    if (s_name.length != 0 ){
        $('#error-nombre').addClass("hide");     
    } else{
        //$('#error-nombre').removeClass("hide");
        toastr["error"]('Campo "Nombre" requerido')
        toastr.options = {
          "closeButton": false,
          "debug": true,
          "newestOnTop": false,
          "progressBar": false,
          "positionClass": "toast-top-right",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }   
        var sendMail = "false";
    } 

    if (s_name.length != 0 ){
        $('#error-apellido').addClass("hide");     
    } else{
        //$('#error-apellido').removeClass("hide");
        toastr["error"]('Campo "teléfono" requerido')
        toastr.options = {
          "closeButton": false,
          "debug": true,
          "newestOnTop": false,
          "progressBar": false,
          "positionClass": "toast-top-right",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }   
        var sendMail = "false";
    }  

    if (s_msg.length != 0 ){
        $('#error-mensaje').addClass("hide");   
    } else{
        //$('#error-mensaje').removeClass("hide");
        toastr["error"]('Debe ingresar sus comentarios')
        toastr.options = {
          "closeButton": false,
          "debug": true,
          "newestOnTop": false,
          "progressBar": false,
          "positionClass": "toast-top-right",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }   
        var sendMail = "false";
    }       


    if( sendMail == "true" ) {

        var datos = {
        "nombre" : $('#nombre').val(),
        "telefono" : $('#telefono').val(),
        "email" : $('#email').val(),   
        "mensaje" : $('#mensaje').val(),
        "codigo_producto" : $('#codigo_producto').val(),
        "img_producto" : $('#img_producto').val(),
        "cenviar" : $('#boton-enviar').val(),
        "_token": getCsrfToken()
    };

    $("#boton-enviar").text("Enviando...");

    $.ajax({
        data:  datos,
        url:   '/enviar-email', 
        type:  'post',
        success:  function (response) {
            toastr["success"]("Solicitud enviada correctamente")
            toastr.options = {
              "closeButton": false,
              "debug": false,
              "newestOnTop": false,
              "progressBar": false,
              "positionClass": "toast-top-right",
              "preventDuplicates": false,
              "showDuration": "300",
              "hideDuration": "1000",
              "timeOut": "5000",
              "extendedTimeOut": "1000",
              "showEasing": "swing",
              "hideEasing": "linear",
              "showMethod": "fadeIn",
              "hideMethod": "fadeOut"
            }
        }

    }).done(function() {
    }).fail(function() {
        toastr["error"]("Ha ocurrido un error al enviar su solicitud")
        toastr.options = {
          "closeButton": false,
          "debug": true,
          "newestOnTop": false,
          "progressBar": false,
          "positionClass": "toast-top-right",
          "preventDuplicates": false,
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        }
    }).always(function() {
        $("#boton-enviar").text("Enviar");
    });
        grecaptcha.reset();
        return true;
    } else {
        grecaptcha.reset();
        return false;
    }
}


function getCsrfToken() { 
   var metas = document.getElementsByTagName('meta'); 

   for (var i=0; i<metas.length; i++) { 
      if (metas[i].getAttribute("name") == "csrf-token") { 
         return metas[i].getAttribute("content"); 
      } 
   } 
    return "";
}